export default "__VITE_ASSET__hQHBrFZK__"